<template>
  <div class="article-page">
    <div class="article-view">
      <div>
        <h2
          class="title"
          align="center"
        >{{ article.Name }}</h2>
        <div class="artical-content scroll-container">
          <div
            class="content"
            v-html="article.Description.replace(/\n/g,'<br/>').replace(/\r/g,'<br/>').replace(/\s/g,'&nbsp;')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ArticleView',
  data () {
    return {
      article: {}
    }
  },
  computed: {
    getId () {
      return this.$route.params.id
    }
  },
  created () {
    this.getArticle()
  },
  methods: {
    getArticle () {
      let introStr = sessionStorage.getItem('intro-' + this.getId)
      this.article = JSON.parse(introStr)
    }
  }
}
</script>


<style lang="scss" scoped>
.article-page {
  // position: absolute;
  // top: 65px;
  // bottom: 0;
  width: 100%;
  overflow-y: auto;

  strong {
    font-weight: bold;
  }
  em {
    font-style: italic;
  }
  ol {
    list-style: decimal;
  }
  ul {
    list-style: disc;
  }
  .article-view {
    width: 1000px;
    margin: 30px auto 50px;
    line-height: 30px;
    .title {
      font-size: 24px;
    }
    img {
      display: block;
      margin: 0 auto;
      max-width: 80%;
    }

    .artical-content {
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/history/intro.vue